import React from 'react';
import PropTypes from 'prop-types';
import { Avatar } from '@domain-group/fe-blueprint-ui/avatar';
import { CallButton } from '@domain-group/fe-co-allhomes-design-system';
import agentType from './props/agent-type';
import * as styles from './agent-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var PrivateListerCard = _ref => {
  var agent = _ref.agent,
    onPhoneClick = _ref.onPhoneClick;
  return ___EmotionJSX("div", {
    css: styles.agentCard
  }, ___EmotionJSX("div", null, ___EmotionJSX(Avatar, {
    css: styles.avatar,
    size: "custom",
    theme: "allhomes"
  })), ___EmotionJSX("div", {
    css: styles.agentDetailsWrapper
  }, ___EmotionJSX("div", {
    css: styles.text
  }, ___EmotionJSX("span", {
    css: styles.name
  }, agent.name)), ___EmotionJSX("div", {
    css: styles.button
  }, agent.phone && ___EmotionJSX(CallButton, {
    css: styles.callButton,
    size: "small",
    phone: agent.phone,
    appearance: "outline",
    onClick: onPhoneClick,
    showIcon: {
      beforeClick: false
    }
  }))));
};
PrivateListerCard.propTypes = {
  agent: PropTypes.shape(agentType).isRequired,
  onPhoneClick: PropTypes.func
};
PrivateListerCard.defaultProps = {
  onPhoneClick: () => {}
};
export default PrivateListerCard;